export default __webpack_public_path__ + "static/media/1465.f33a2b54.png";